import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import type { Variant } from "@mui/material/styles/createTypography";

type IProps = {
  profit: number;
  risk: number;
  score: number;
  scoreDecimals?: number;
  profitLabelColor?: string;
  riskLabelColor?: string;
  profitColor?: string;
  riskColor?: string;
  profitBgcolor?: string;
  riskBgcolor?: string;
  profitBorderRadius?: string;
  riskBorderRadius?: string;
  variantTitle?: Variant;
  variant?: Variant;
  px?: number;
  py?: number;
};

/**
 * Box to display profit & risk
 * @component
 * @example
 * <ScoreBox profit={50.54} risk={10} />
 */
const ScoreBox = function ({
  profit,
  risk,
  score,
  profitLabelColor = "secondary",
  riskLabelColor = "secondary",
  profitColor = "#11CC9A",
  riskColor = "#253E66",
  profitBgcolor = "#253E66",
  riskBgcolor = "#E5AA17",
  profitBorderRadius = "10px 10px 0 10px",
  riskBorderRadius = "0 10px 0 0",
  variantTitle = "caption",
  variant = "body1",
  px = 1,
  py = 0.3,
  scoreDecimals = 1,
}: IProps) {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("es") ? "es-ES" : "en-US";
  const formatScore = (value: number) =>
    value.toLocaleString(lang, {
      minimumFractionDigits: scoreDecimals,
      maximumFractionDigits: scoreDecimals,
    });
  return (
    <Box display="flex">
      <Box display="flex" alignItems="center">
        <Box
          bgcolor={profitBgcolor}
          color={profitColor}
          display="flex"
          flexDirection="column"
          borderRadius={profitBorderRadius}
          px={px}
          mr="1px"
          py={py}
        >
          <Typography
            color={profitLabelColor}
            variant={variantTitle}
            fontWeight={700}
          >
            Score
          </Typography>
          <Typography fontWeight={500} fontFamily="Poppins" variant={variant}>
            {score > 0 && "+"}
            {formatScore(score)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ScoreBox;
